import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import { Color, Brand } from '../../../lib/theme';
import spinnerStyles from './Spinner_styles';

export interface SpinnerProps {
  brand?: Brand;
  className?: string;
  backgroundColor?: string;
  children: React.ReactNode;
}

const Spinner = ({
  className,
  children,
  styles,
}: SpinnerProps & StylesProps<typeof spinnerStyles>) => (
  <div className={cx('Spinner', styles.container, className)}>
    <img
      src={`https://images.startsat60.com/frontend/SAS-Opinion-Logo-spinner.gif`}
    />
    {children}
  </div>
);

export default styled(spinnerStyles)(Spinner);